export default __webpack_public_path__ + "static/media/github_logo.5e126f5b.png";